import { useContext } from 'react'
import { contractsCarsContext } from '../../pages/vehicle/contracts'
import { CarSearchForm } from './CarSearchForm'

export const ContractsCarSearch = () => {
  const { updateFilter, filter } = useContext(contractsCarsContext)

  return (
    <CarSearchForm
      filter={filter}
      onSubmit={updateFilter}
      listType='contracted'
    />
  )
}


